import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import ProductDetailPage from '../components/custom-components/ProductDetailPage';
import productData from '../data/products.json';

export default function Product() {
  const { categoryId, productId } = useParams();
  const product = productData.products.find(p => p.id === productId);
  const category = product ? product.categoryId : null;
  const siteUrl = 'https://baggainternational.com'; // TODO: Replace with your actual domain

  if (!product) {
    return (
      <div className="container mx-auto px-4 py-8">
        <h2 className="text-3xl font-bold text-center mb-8">Product not found</h2>
      </div>
    );
  }

  const metaDescription = product.shortDescription || (product.description && product.description[0]) || product.name;
  const canonicalUrl = `${siteUrl}/categories/${categoryId}/${productId}`;

  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet>
          <title>{`${product.name} | Bagga International`}</title>
          <meta name="description" content={metaDescription} />
          <link rel="canonical" href={canonicalUrl} />
          {/* Open Graph tags */}
          <meta property="og:title" content={product.name} />
          <meta property="og:description" content={metaDescription} />
          <meta property="og:image" content={product.image} />
          <meta property="og:url" content={canonicalUrl} />
          <meta property="og:type" content="product" />
          {/* Twitter Card tags */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={product.name} />
          <meta name="twitter:description" content={metaDescription} />
          <meta name="twitter:image" content={product.image} />
          {/* Structured Data (JSON-LD) */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org/",
              "@type": "Product",
              "name": product.name,
              "image": [product.image],
              "description": metaDescription,
              "sku": product.sku,
              "brand": {
                "@type": "Brand",
                "name": "Bagga International"
              },
              "category": categoryId
            })}
          </script>
        </Helmet>
      </HelmetProvider>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Product Details</h1>
        <p className="text-lg mb-4">Product ID: {productId}</p>
        <ProductDetailPage />
      </div>
    </React.Fragment>
  );
}

